/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateMerchantCapabilities} from '../api'

export const useMutationUpdateMerchantCapabilities = createReactQueryMutationHook('updateMerchantCapabilities', updateMerchantCapabilities)
